module.exports = __webpack_public_path__ + "img/bridge_placeholder.152a3941.png";